/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Email_PasswordInputs */



/**
* | output |
* | --- |
* | "Email & Password" |
*
* @param {Profile_Email_PasswordInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_email_password = /** @type {((inputs?: Profile_Email_PasswordInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Email_PasswordInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Email & Mot de passe")
	if (locale === "es") return /** @type {LocalizedString} */ ("Email y contraseña")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Email e senha")
	if (locale === "it") return /** @type {LocalizedString} */ ("Email e password")
	return /** @type {LocalizedString} */ ("Email & Password")
});